import {useCallback, useSyncExternalStore} from 'react';
import type {Component} from 'grapesjs';
import {getComponentStyleProperty} from '@FormMakerReact/lib/form-maker-style-library';

export function useComponentStyleProperty(component: Component, property: string): string {
  const subscribe = useCallback(
    (onChange: () => void) => {
      component.on('change:style', onChange);
      return (): void => {
        component.off('change:style', onChange);
      };
    },
    [component]
  );
  const getSnapshot = useCallback(() => getComponentStyleProperty(component, property), [component, property]);
  return useSyncExternalStore(subscribe, getSnapshot);
}
